import React from "react";
import Table from "react-bootstrap/Table";

export const TableSkeleton = ({ rows = 5, columns = 8, headers }) => {
  const numCols = headers && headers.length > 0 ? headers.length : columns;

  return (
    <div className="crm-table-container">
      <style>{`
        @keyframes skeleton-shimmer {
          0% {
            background-position: -200px 0;
          }
          100% {
            background-position: calc(200px + 100%) 0;
          }
        }
        .skeleton-box {
          display: inline-block;
          height: 16px;
          width: 100%;
          border-radius: 4px;
          background-color: #e5e7eb;
          background-image: linear-gradient(
            90deg,
            #e5e7eb 0px,
            #f3f4f6 50px,
            #e5e7eb 100px
          );
          background-size: 200px 100%;
          background-repeat: no-repeat;
          animation: skeleton-shimmer 1.4s infinite ease-in-out;
        }
      `}</style>
      <Table responsive className="crm-table">
        <thead>
          <tr>
            {headers && headers.length > 0 ? (
              headers.map((h, i) => <th key={i}>{h}</th>)
            ) : (
              Array.from({ length: columns }).map((_, i) => (
                <th key={i}>
                  <div className="skeleton-box" style={{ height: "14px", width: "60%" }} />
                </th>
              ))
            )}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: numCols }).map((_, colIndex) => (
                <td key={colIndex}>
                  <div
                    className="skeleton-box"
                    style={{
                      width:
                        colIndex === 0
                          ? "35%"
                          : colIndex === 1
                          ? "50%"
                          : colIndex % 2 === 0
                          ? "80%"
                          : "65%",
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

const TableLoader = ({ rows = 5, columns = 8, headers }) => {
  return <TableSkeleton rows={rows} columns={columns} headers={headers} />;
};

export default TableLoader;
